<template>
  <div>
    <div class="banner-container">
      <div class="banner-overlay">
        <div class="container banner-overlay-content-container">
          <div class="banner-text-wrapper">
            <h1>
              Why
              <br />Choose Us?
            </h1>
            <hr />
            <p>
              <font-awesome-icon icon="check" />&nbsp;Reliable and responsive service
              <br />
              <font-awesome-icon icon="check" />&nbsp;Qualified and highly experienced staff
              <br />
              <font-awesome-icon icon="check" />&nbsp;Wide Geogrpahic coverage
            </p>
            <router-link to="/contact-us/" class="btn">Contact Us</router-link>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6"></div>
        <div class="col-lg-6">
          <div class="image-partial">
            <div class="img-cover"></div>
          </div>
        </div>
      </div>
      <div class="yellow-background"></div>
      <div class="banner-image"></div>
    </div>
    <div class="about-container">
      <div class="about-overlay">
        <div class="container about-overlay-content-container">
          <div class="about-text-wrapper">
            <h2>
              <strong>About Us</strong>
            </h2>
            <hr />
            <strong>We offer a range of distinct features to our clients that are relevant to the type and/or size of the services required.</strong>
            <br />
            <br />
            <p>Enquiries made to us are dealt with promptly. Quotations are provided working closely with the client; we ensure all information is available to enable us to provide a satisfactory and cost effective service.</p>
            <p>Risk Assessments and Method Statements are provided for successfully secured contracts. We will also apply for any scaffolding Licences should they be required. An Inspection service is also available.</p>
            <router-link to="/about-us/" class="btn">Read More</router-link>
            <br />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6"></div>
        <div class="col-lg-6">
          <div class="image-partial">
            <div class="img-cover"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="services">
      <div class="container">
        <div class="row">
          <div class="col-12 col-lg-auto mr-4 mb-3 mb-lg-0">
            <h2>Our Services</h2>
            <hr class="mt-0 mb-0" />
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-6 service-card">
            <div class="box">
              <router-link to="/services/">
                <div class="home-card-image home-card-image--1"></div>
                <div class="content">
                  <h2>Scaffold Services</h2>
                  <p>
                    We provide many services to our clients from safety deck systems to full encapsulations.
                    Please get in contact to find out more about the wide range of services we supply
                  </p>
                  <span class="btn">Read More</span>
                </div>
              </router-link>
            </div>
          </div>
          <div class="col-12 col-md-6 service-card">
            <div class="box">
              <router-link to="/services/">
                <div class="home-card-image home-card-image--2"></div>
                <div class="content">
                  <h2>Project Managment</h2>
                  <p>
                    SEA Scaffolding isn’t just a scaffold company. We consult with all our clients from the get go to ensure
                    job satisfaction is assured. We can offer advice and the most cost effective solution to all access issues.
                  </p>
                  <span class="btn">Read More</span>
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="testimonials">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <h2>Testimonials</h2>
            <hr />
            <swiper :options="swiperOption">
              <!-- slides -->
              <swiper-slide>
                <div class="quote-content">
                  <p>I have employed the SEA team on a number of occasions and always found them to very helpful and accommodating, going out of their way to help. Most of my requirements are not run of the mill but SEA always find a solution. I shall be continuing to use them in the future.</p>
                  <p class="author">
                    Steve Howard
                    <br />Technical Planner (Essex)
                  </p>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="quote-content">
                  <p>Its been a pleasure to work with Ollie and all of SEA, throughout the project all works booked in, big or small were complete on time and to a high standard. I would highly recommend SEA and I am looking forward to working with them in the future.</p>
                  <p class="author">
                    Matthew Smith
                    <br />&nbsp;&nbsp;&nbsp;Site Manager
                    <br />&nbsp;&nbsp;&nbsp;Lovell
                  </p>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="quote-content">
                  <p>
                    SEA scaffold provided us with a large scaffold at the foot of our maternity block here at Ipswich Hospital, it was up for some time whilst the building had some repairs completed. Once these repairs were completed I contacted Ollie to have the scaffold removed and he couldn’t have been more helpful, he quickly came back to me with a date for removal along with all the paperwork required for this to go ahead safely.
                    The lads who attended site were professional and worked hard to remove the scaffold in the time allocated despite the temperature being very high.
                    They couldn’t have worked harder and I would more than happy work with Sea scaffold again in the future.
                  </p>
                  <p class="author">
                    Jordan Beaumont
                    <br />&nbsp;&nbsp;&nbsp;New Works Team
                    <br />&nbsp;&nbsp;&nbsp;East Suffolk and North Essex NHS Foundation Trust
                  </p>
                </div>
              </swiper-slide>
              <div class="swiper-pagination swiper-pagination-bullets" slot="pagination"></div>
            </swiper>
            <span class="left-quote">
              <font-awesome-icon icon="quote-left" />
            </span>
            <span class="right-quote">
              <font-awesome-icon icon="quote-right" />
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="cta">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-8 col-lg-4 col-xl-3">
            <h2>Get In Touch</h2>
          </div>
          <div class="col-md-8 col-lg-5 col-xl-6 mt-3 mt-lg-0">
            <p class="details">
              To receive a competitive quotation from an established company like SEA Scaffolding then please do not hesitate to forward any information over to
              <a
                href="mailto:info@seascaffolding.com"
              >info@seascaffolding.com</a> or call
              <a href="tel:01502711750">01502 711750</a> for a free quotation
            </p>
          </div>
          <div
            class="col-md-4 col-lg-3 col-xl-3 d-flex mt-3 mt-lg-0 align-items-center justify-content-center mx-auto"
          >
            <router-link to="/contact-us/" class="button-wrapper text-lg-right">
              <div class="btn get-in-touch-button test-wrap">Contact Us</div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";

export default {
  name: "Home",
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      swiperLogoOptions: {
        loop: true,
        centeredSlides: false,
        slidesPerView: 4,
        spaceBetween: 50,
        navigation: {
          nextEl: ".logo-swiper-button-next",
          prevEl: ".logo-swiper-button-prev",
        },
        autoplay: {
          delay: 2000,
          reverseDirection: true,
        },
        breakpoints: {
          1218: {
            slidesPerView: 3,
          },
          768: {
            slidesPerView: 3,
          },
          576: {
            slidesPerView: 1,
          },
        },
      },
      swiperOption: {
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          renderBullet(index, className) {
            return `<span class="${className} swiper-pagination-bullet-custom"></span>`;
          },
        },
        spaceBetween: 30,
        centeredSlides: true,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
      },
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.swiper-pagination-fraction,
.swiper-pagination-custom,
.swiper-container-horizontal > .swiper-pagination-bullets {
  bottom: 0px !important;
}

.swiper-pagination-bullet {
  cursor: pointer;
  width: 8px !important;
  height: 8px !important;
  display: inline-block !important;
  border-radius: 100% !important;
  background: #fff !important;
  border: 1px solid #e81a2e !important;
  opacity: 1 !important;
  margin: 0 8px !important;
}

.swiper-pagination-bullet-active {
  background: #e81a2e !important;
}

#testimonials .swiper-container {
  height: auto;
}

.details a {
  color: #fff;
  text-decoration: underline;
}
@media screen and (max-width: 769px) {
  #testimonials .swiper-container,
  #testimonials .quote-content {
    font-size: 16px;
  }
  #testimonials .quote-content p.author {
    font-size: 18px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Home.vue